// extracted by mini-css-extract-plugin
export var formContainer = "_jh-0";
export var message = "_jh-1";